/* Copyright (c) 2020-present CloudIO Inc */

export default function assert(condition: boolean, message: string): void {
  if (process.env.NODE_ENV !== 'production') {
    if (!condition) {
      throw Error(`Assert failed: ${message}`);
    }
  }
}
